import {
  VIRTUAL_PHARMACIES,
  componentIds,
  genericActionsIds,
} from 'utilities/constants';
import Modal from 'components/modal/modalComponent';
import { useGetComponent } from 'hooks/useGetComponent';
import { useGetGenericActions } from 'hooks/useGetGenericActions';
import { ModalButtonProps } from './modal/modal.interfaces';
import { FullScriptIframe } from './FullScriptIframe';
import { createModal } from 'layout/createModal';
import {
  useGetProviderPatientDetailsLazyQuery,
  useGetProviderPatientDetailsQuery,
} from '../graphql/generated/remote-schema-hasura';
import { useState } from 'react';
import { interpolateVariables } from '../utilities/functions';

interface PrescribeMedicationModalProps {
  platform: string;
  appointmentCodexId?: string;
  encounterId?: string;
  patientId: string;
  onCloseCallback?: () => void;
}

export const PRESCRIBE_MEDICATION_MODAL_KEY = 'prescribe-medications';

export const PrescribeMedicationModal = createModal<
  PrescribeMedicationModalProps,
  void
>(PRESCRIBE_MEDICATION_MODAL_KEY, ({ isOpen, state, close }) => {
  const { platform, appointmentCodexId, patientId } = state;
  const { data: locale, loading } = useGetComponent({
    locale: 'en',
    componentId: componentIds.VIRTUAL_PHARMACY_MODAL,
  });

  const [patientName, setPatientName] = useState<string>('');
  const [childName, setChildName] = useState<string>('');
  const [parentName, setParentName] = useState<string>('');

  const setError = (errorMessage: string) => console.log(errorMessage);

  // const { addToast } = useCustomToast();
  //
  // const setError = (errorMessage: string) => {
  //   addToast({
  //     type: 'warning',
  //     message: errorMessage,
  //   });
  // };

  const handleClose = () => {
    state.onCloseCallback && state.onCloseCallback();
    close();
  };

  const { data: genericAction, loading: genericActionLoading } =
    useGetGenericActions({
      locale: 'en',
      genericActionId: [
        genericActionsIds.SKIP_THIS_STEP,
        genericActionsIds.CLOSE,
      ],
    });

  const [getPatientById, { loading: loadingParentData }] =
    useGetProviderPatientDetailsLazyQuery({
      onCompleted: (data) => {
        const parent = data.getFHIRPatientbyCodexIDParameter.users[0];

        setParentName(
          parent.SENSITIVE_firstname + ' ' + parent.SENSITIVE_lastname,
        );
      },
    });

  const { loading: loadingPatientData } = useGetProviderPatientDetailsQuery({
    variables: {
      patientCodexId: patientId as string,
    },
    onCompleted: (data) => {
      const patient = data.getFHIRPatientbyCodexIDParameter.users[0];
      const patientName =
        patient.SENSITIVE_firstname + ' ' + patient.SENSITIVE_lastname;
      setPatientName(patientName);

      if (!data.getFHIRPatientbyCodexIDParameter.users[0].parentCodexId) return;
      setChildName(patientName);
      getPatientById({
        variables: { patientCodexId: patient.parentCodexId as string },
      });
    },
  });

  const Buttons: ModalButtonProps[] = [
    {
      label: genericAction?.[genericActionsIds.CLOSE].close,
      disabled: false,
      onClick: handleClose,
      testID: 'close',
    },
    // ,
    // {
    //   label: genericAction?.[genericActionsIds.SKIP_THIS_STEP].skipThisStep,
    //   disabled: false,
    //   onClick: () => console.log('skip this step'),
    //   type: 'outlined',
    // },
  ];

  if (
    loading ||
    !locale ||
    genericActionLoading ||
    loadingPatientData ||
    loadingParentData
  )
    return null;

  return (
    <Modal
      isOpen={isOpen}
      title={locale?.modalTitle}
      subtitle={
        parentName && platform === VIRTUAL_PHARMACIES.fullscript
          ? interpolateVariables(locale.selectParent, {
              childName,
              parentName,
            })
          : ''
      }
      modalDesktopWidth="desktop:max-w-[1140px]"
      contentPaddingX="!px-0"
      contentPaddingY="py-0"
      contentContainerDefaultBackground="bg-white"
      onClose={handleClose}
      buttons={Buttons}
    >
      <div className="flex flex-col gap-[30px]">
        <div className="flex flex-col py-2.5 bg-white items-center justify-center w-full min-h-[790px] h-[70vh]">
          {platform === VIRTUAL_PHARMACIES.fullscript && (
            <FullScriptIframe
              patientId={patientId}
              patientName={patientName}
              appointmentCodexId={appointmentCodexId}
              setError={setError}
            />
          )}
        </div>
      </div>
    </Modal>
  );
});
